export const config = {
    apiUrl: 'https://api.lolvoting.goddchen.de'
    //apiUrl: 'http://localhost:3000'
}